import React from 'react'
import { useNavigate } from 'react-router-dom'
import {
  LoginContent,
  Modal,
  ModalContainer
} from '../../../../../apps/super-app/src/pages/WaitList/WaitListLogin/WaitListLogin.styles'
import { Subtitle } from '../../../../../apps/super-app/src/pages/WaitList/commonStyles'
import { Button } from 'shared-ui/components'
import { useResponsive } from 'shared-ui/hooks'
import { media } from 'shared-ui/utils/media.js'
import { useTheme } from 'styled-components'
import { close } from 'shared-ui/assets'
import { INVITE_STATUS_MESSAGES, PICK_FROM_LIST, ROUTES } from '../../utils/constants'

const InviteModal = ({
  header,
  message,
  onClick,
  retryButton = false,
  handleRetry = () => {},
  confirmText,
  cancelText,
  minHeight,
  isCreditsError = false,
  isSubscribeError = false,
  onClose,
  children,
  errorCode,
  width,
  mobilePadding,
  footerRowReverse = false,
  disableConfirmButton = false
}) => {
  const navigate = useNavigate()
  const theme = useTheme()
  const isMobile = useResponsive(media.mobile)

  const isNotSent =
    header === INVITE_STATUS_MESSAGES?.NOT_SENT?.HEADER || retryButton

  const closeButtonText = cancelText || PICK_FROM_LIST?.CLOSE_BTN
  const retryButtonText = confirmText || 'Try Again'

  const baseButtonStyle = {
    textAlign: isMobile ? 'end' : 'center',
    alignSelf: 'end',
    padding: isMobile ? (mobilePadding || '10px 12px') : '10px 24px',
    cursor: 'pointer'
  }

  const handleTopUpAction = (e) => {
    if (typeof onClick === 'function') {
      onClick(e)
    }
    if (typeof onClose === 'function') {
      onClose(e)
    }
    navigate(ROUTES.subscription, {
      state: {
        fromWalletTopUp: 'topup'
      }
    })
  }

  const handleUpgradeAction = (e) => {
    if (typeof handleRetry === 'function') {
      handleRetry(e)
    }
    if (typeof onClose === 'function') {
      onClose(e)
    }
    navigate(ROUTES.subscription)
  }

  // const hasHTML = (text = '') =>
  // /<\/?[a-z][\s\S]*>/i.test(text);
  const buttonBorder = isCreditsError || isMobile
    ? 'transparent'
    : isNotSent
      ? '1px solid #00B8F8'
      : 'transparent'

  const stripHTML = (value = '') => {
    if (typeof value !== 'string') return value

    const div = document.createElement('div')
    div.innerHTML = value
    return div.textContent || div.innerText || ''
  }

  return (
    <ModalContainer theme={theme}>
      <Modal
        theme={theme}
        $gap="30px"
        $padding={isMobile ? '24px' : '32px'}
        $height={minHeight || (isMobile ? '212px' : '256px')}
        $width={width ? width : isMobile ? '312px' : '480px'}
        $bg={isMobile ? theme.app.optionsBg : theme.app.background}
      >
        <LoginContent style={{ alignItems: 'start' }}>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              width: '100%'
            }}
          >
            <Subtitle
              theme={theme}
              style={{ fontSize: '20px', fontWeight: 600, textAlign: 'start',textTransform:"capitalize" }}
            >
              {header}
            </Subtitle>
            {!isMobile && (
              <img
                src={close}
                alt="close modal"
                onClick={onClose}
                style={{ cursor: 'pointer' }}
              />
            )}
          </div>

          {message && (
            <Subtitle
              theme={theme}
              style={{ textAlign: 'start', fontSize: '14px', fontWeight: 400, wordBreak: 'break-word', overflowWrap: 'anywhere' }}
            >
              {stripHTML(message)}
            </Subtitle>
          )}
          {children && <div style={{ width: '100%' }}>{children}</div>}

          <div>
            {errorCode && (
              <Subtitle
                theme={theme}
                style={{ textAlign: 'start', fontSize: '14px', fontWeight: 400 }}
              >
                {INVITE_STATUS_MESSAGES?.ERROR_CODE}: {errorCode}
              </Subtitle>
            )}
          </div>
        </LoginContent>

        <div
          style={{
            display: 'flex',
            flexDirection: isMobile || footerRowReverse  ? 'row' : 'row-reverse',
            gap: isMobile ? '8px' : '16px',
            alignItems: 'center',
            alignSelf: isMobile ? 'end' : 'start'
          }}
        >
          <Button
            theme={theme}
            cursor="pointer"
            background={
              isCreditsError
                ? 'transparent'
                : isMobile
                  ? 'transparent'
                    : isNotSent
                      ? 'transparent'
                      : '#00B8F8'
            }
            border={buttonBorder}
            padding="0px 24px"
            style={{
              ...baseButtonStyle,
              cursor: 'pointer',
              pointerEvents: 'auto',
              minHeight:"40px",
              color: isCreditsError
                ? '#00B8F8'
                : isMobile
                  ? '#00B8F8'
                    : isNotSent
                      ? '#00B8F8'
                      : theme.colors.White
            }}
            onClick={isCreditsError ? handleTopUpAction : onClick}
          >
            {closeButtonText}
          </Button>

          {isNotSent && (
            <Button
              theme={theme}
              cursor="pointer"
              padding="0px 24px"
              border={buttonBorder}
              background={isCreditsError ? 'transparent' : isMobile ? 'transparent' : '#00B8F8'}
              style={{
                ...baseButtonStyle,
                cursor: 'pointer',
                pointerEvents: 'auto',
                color: isMobile ? '#00B8F8' : isCreditsError ? '#00B8F8' : theme.colors.White,
                minHeight:"40px"
              }}
              onClick={isCreditsError ? handleUpgradeAction : handleRetry}
              disabled={disableConfirmButton}
            >
              {retryButtonText}
            </Button>
          )}
        </div>
      </Modal>
    </ModalContainer>
  )
}

export default InviteModal
